<script setup lang="ts">
import {useTemplateRef, useSlots, computed} from "vue";
import useDraggableColumnWidths from "@/Composables/draggableColumnWidth.ts";

const slots = useSlots();
const hasRightContent = computed(() => !!slots.right && !!slots.right().length);

const resizeColumnsDragHandle = useTemplateRef("resizeColumnsDragHandle");
const resizableColumns = useTemplateRef("resizableColumns");
const {columnWidths, isDragging} = useDraggableColumnWidths(resizableColumns, resizeColumnsDragHandle);
</script>
<template>
    <div class="relative w-full gap-2 xl:flex" ref="resizableColumns">
        <div :style="hasRightContent ? `width: ${columnWidths.left}%` : 'width: 100%'">
            <slot name="left" />
        </div>
        <div v-if="hasRightContent" class="group cursor-col-resize px-1" ref="resizeColumnsDragHandle">
            <div
                class="h-full flex-none border-2 border-dashed transition-colors active:border-askr-green group-hover:border-askr-green xl:block"
                :class="{'border-askr-green': isDragging}"
            ></div>
        </div>
        <div v-if="hasRightContent" :style="`width: ${columnWidths.right}%`">
            <slot name="right" />
        </div>
    </div>
</template>
<style scoped></style>
